import React from "react";
import { Link } from "react-router-dom";
import Icon from "./Icon";
import { brand, footerSimple, contact } from "../data/siteData";
import "../styles/Footer.css";

// Self-contained plain social-icon footer — used only on the
// Request a Quote page, kept minimal so the form stays the focus.
export default function FooterSimple() {
  const year = new Date().getFullYear();

  return (
    <footer className="tp-footer tp-footer--simple">
      <div className="tp-container tp-footer-simple__social">
        <span>{footerSimple.followLabel}</span>
        <div className="tp-footer-simple__icons">
          {footerSimple.social.map((social) => (
            <a key={social.label} href="/" aria-label={social.label} className="tp-footer-simple__icon">
              <Icon name={social.icon} size={17} />
            </a>
          ))}
        </div>
      </div>

      <div className="tp-container tp-footer-simple__links">
        {footerSimple.links.map((link) => (
          <Link key={link.label} to={link.path}>
            {link.label}
          </Link>
        ))}
      </div>

      <div className="tp-footer__bottom">
        <div className="tp-container tp-footer__bottom-inner">
          <span>
            &copy; {year} {brand.name}. All rights reserved.
          </span>
          <span>
            {footerSimple.callUsLabel} {contact.phones.join(", ")}
          </span>
        </div>
      </div>
    </footer>
  );
}
